<template>
  <svg
    aria-hidden="true"
    width="90px"
    height="90px"
    viewBox="0 0 100.11 100.11"
    :class="$attrs.class"
  >
    <path
      :fill="color"
      d="M50.05,100.17C22.41,100.17,0,77.76,0,50.12S22.41.07,50.05.07s50.05,22.41,50.05,50.05-22.41,50.05-50.05,50.05"
    />
    <path
      fill="#fff"
      d="M33.22,64.61h-.1c-6.11,0-11.08,3.95-11.12,8.84-.03,4.92,4.94,8.96,11.09,9.01h.1
         c6.11,0,11.08-3.95,11.12-8.84,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03v-36.55l22.32-11.16v27.24
         c-1.85-1.13-4.13-1.83-6.63-1.84h-.1
         c-6.1,0-11.08,3.95-11.12,8.84-.03,4.92,4.94,8.96,11.09,9.01h.1
         c6.11,0,11.08-3.95,11.12-8.84,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03V22.22
         c0-.77-.4-1.49-1.06-1.9-.66-.4-1.48-.44-2.17-.1l-26.78,13.39
         c-.76.38-1.23,1.15-1.23,1.99v30.85
         c-1.85-1.13-4.13-1.83-6.63-1.84"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#127b5d",
    },
  },
};
</script>
